import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  console.log('response: ', response)
  const data = isSuccessResponse(response)

  return data.map((item: any) => ({
    id: item?.id,
    ruleName: item?.ruleName,
    payeeType: item?.payeeType,
    payeeUserId: item?.payeeUserId,
    payeeVpa: item?.payeeVpa,
    payerBankId: item?.payerBankId,
    binList: item?.binList,
    binRange: item?.binRange,
    cardType: '' + item?.cardType,
    scheme: '' + item?.scheme,
    amount: item?.amount,
    transactionInitiatingEntityId: '' + item?.transactionInitiatingEntityId,
    transactionApplication: item?.transactionApplication,
    txntype: '' + item?.txntype,
    instrumentType: '' + item?.instrumentType,
    mode: item?.mode,
    activationGroup: item?.activationGroup,
    priority: item?.priority,
    processor: item?.processor,
    isActive: item?.isActive,
    isAssigned: item?.isAssigned,
  }))
}

const getAllRules = (tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.getAllRules),
    method: 'GET',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { getAllRules }
